import {
  useQueryStates,
  parseAsStringLiteral,
  parseAsString,
  parseAsInteger,
} from 'nuqs'
import { WAGE_JURISDICTION_LEVELS } from 'pages/Wage/types'

export const useJurisdictionFiltersQueryState = () => {
  return useQueryStates(
    {
      level: parseAsStringLiteral(WAGE_JURISDICTION_LEVELS),
      stateCode: parseAsString,
      pageIndex: parseAsInteger.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
    },
    {
      urlKeys: {
        stateCode: 'state',
        pageIndex: 'page',
        pageSize: 'page-size',
      },
    }
  )
}
